export default function AboutUs2(){
    return (
    <section className="py-24 relative xl:mr-0 lg:mr-5 mr-0 bg-white">
        <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
            <div className="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-2 grid-cols-1">
                <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
                    <div className="w-full flex-col justify-center items-start gap-8 flex">
                        <div className="flex-col justify-start lg:items-start items-center gap-4 flex">
                            <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                                <h2
                                    className="text-green-700 text-4xl font-bold font-manrope leading-normal lg:text-start text-center">
                                    WITS is grounded in three innovation pathways</h2>
                                <p
                                    className="text-gray-500 text-base font-normal leading-relaxed lg:text-start text-center">
                                    WITS aims to change the narrative of conservation from one of anecdotal effort to
evidence-based action, measured impact, and collective intelligence.</p>
                            </div>
                        </div>
                        <div className="w-full flex-col justify-center items-start gap-6 flex">
                            <div className="w-full justify-start items-center gap-8 grid md:grid-cols-1 grid-cols-1">
                                <div
                                    className="w-full h-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                                    <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">Fostering Innovation</h4>
                                    <p className="text-gray-500 text-base font-normal leading-relaxed">
                                        By addressing real-world conservation challenges, WITS pilots
emerging technologies in practical settings.
                                    </p>
                                </div>
                                <div
                                    className="w-full h-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                                    <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">Technology Adoption and Application
                                    </h4>
                                    <p className="text-gray-500 text-base font-normal leading-relaxed">
                                        WITS supports conservation practitioners in
embedding technological tools into daily operations, ensuring they are effective and
adaptable to on-the-ground realities.
                                    </p>
                                </div>
                            </div>
                            <div className="w-full h-full justify-start items-center gap-8 grid md:grid-cols-1 grid-cols-1">
                                <div
                                    className="w-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                                    <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">Usability and Scaling</h4>
                                    <p className="text-gray-500 text-base font-normal leading-relaxed">
                                        With a focus on user-centered design, WITS will be accessible to a
wide range of users, from local community scouts to national policymakers, making its
impact broad and replicable.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div className="w-full lg:justify-start justify-center items-start flex">
                    <div
                        className="sm:w-[564px] w-full sm:h-[646px] h-full sm:bg-gray-100 rounded-3xl sm:border border-gray-200 relative">
                        <img className="sm:mt-5 sm:ml-5 w-full h-full rounded-3xl object-cover"
                            src="/images/v1/img15.jpg" alt="about Us" />
                    </div>
                </div>
            </div>
        </div>
    </section>
                                            
    )
}